import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { message } from 'antd'
import AdminPageTitle from '../../../components/AdminPageTitle/AdminPageTitle'
import { PageForm, PageFormFields } from '../../../components/PageForm/PageForm'
import pagesService from '../../../services/pagesService'
import { Page } from '../../../services/models'
import { Helmet } from 'react-helmet-async'
import { BackwardOutlined } from '@ant-design/icons'

export const AdminPageEditPage: React.FC = () => {
  const { id: pageId } = useParams()
  const navigate = useNavigate()
  const [page, setPage] = useState<Page>()

  const fetchPage = () => {
    if (!pageId) {
      return
    }
    pagesService.getById(+pageId).then((data) => {
      setPage(data.page)
    }).catch((error) => {
      message.error(error.message)
    })
  }

  useEffect(() => {
    fetchPage()
  }, [])

  const onUpdatePage = ({ title, url, content }: PageFormFields) => {
    if (!page) {
      return
    }
    pagesService.update(page.id, title, url, content).then((data) => {
      message.success(`Страница "${data.title}" успешно отредактирована`)
      navigate('/pages')
    }).catch((error) => {
      message.error(error.message)
    })
  }

  if (!page) {
    return <div>Загрузка...</div>
  }

  return (
    <div>
      <Helmet><title>{`Prisma — ${page.title}`}</title></Helmet>
      <AdminPageTitle
        title={page.title}
        buttonText={'Назад'}
        icon={<BackwardOutlined/>}
        onClickButton={() => navigate('/pages')}
      />
      <PageForm data={page} onSubmit={onUpdatePage}/>
    </div>
  )
}
